import { client } from '@/client';
import {
  SecurityProfileQuiz,
  SecurityProfileResponse,
} from '@/client/security-profile';
import { GenericForbiddenApiError } from '@/hooks/query/types';
import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';

const queryKey = 'security-profile-quiz';

export const useSecurityProfileQuiz = (
  accountId: string,
  params?: UseQueryOptions<SecurityProfileQuiz>,
): UseQueryResult<SecurityProfileQuiz> & {
  quiz: SecurityProfileQuiz | undefined;
} => {
  const {
    retry = false,
    retryDelay = 500,
    staleTime = 0,
    cacheTime = 300000,
    ...restOptions
  } = params || {};

  const { data, ...rest } = useQuery<SecurityProfileQuiz>(
    [queryKey, accountId],
    () => client.securityProfile.getSecurityProfileQuiz(accountId),
    {
      retry,
      retryDelay,
      staleTime,
      cacheTime,
      enabled: !!accountId,
      ...restOptions,
    },
  );

  return {
    quiz: data,
    ...(rest as UseQueryResult<SecurityProfileQuiz>),
  };
};

export const useSubmitSecurityProfileResponses = (accountId: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, GenericForbiddenApiError, SecurityProfileResponse[]>(
    'submitSecurityProfileResponses',
    (responses) =>
      client.securityProfile.submitSecurityProfileResponses(
        accountId,
        responses,
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey, accountId]);
        queryClient.invalidateQueries(['admin-tasks']);
      },
    },
  );
};
